const RESOURCE_EDIT_SIZE = 800;
const RESOURCE_BASE_SIZE = 100;
/**
 * 매개변수
 *   original
 *      Web API의 File 객체 (참고: https://developer.mozilla.org/ko/docs/Web/API/File)
 *
 *   options (json object)
 *      type: 워터마크의 타입 'image' or 'text'
 *      source: 워터마크의 리소스이며 타입이 'image' 일 경우 File 객체, 'text' 일 경우 문자열
 *      thumbnail(json object): 편집기용도의 썸네일과, 리스트에서 보여주는 썸네일의 설정
 *
 *      {
 *           editor: {
 *                mode: 'imageFull',
 *                waterMark: true
 *           },
 *           tiny: {
 *                mode: 'paperFull',
 *                waterMark: true
 *           }
 *      }
 *
 *      editor: 편집기용도의 썸네일, tiny: 리스트용도의 썸네일
 *      mode: 'imageFull' or 'paperFull', waterMark: 워터마크 표시 여부 boolean
 *
 * 반환 값
 *   ed: 변환된 편집기용 이미지
 *   thumb: 변환된 리스트용 이미지
 *   realWidth: 원본 넓이
 *   realHeight: 원본 높이
 */
export const getWaterMarkImages = (function () {
  const g = async (t, e) => {
    let n = t.width * 2;
    let a = t.height * 2;
    const { canvas: i, ctx: o } = B(n, a);
    o.drawImage(t, 0, 0, n, a);
    return await v(i, e);
  };
  const d = async (t, e, n, a, i, o, s, h, c, l) => {
    let r = null;
    let g = null;
    let d = null;
    if (o) {
      r = M(t.width, t.height, n, n, 0);
    } else {
      r = C(t.width, t.height, n, n, 0);
    }
    if (c) {
      r = c;
    }
    if (h) {
      g = A(t, n, 1, r.x, r.y, r.width, r.height);
      d = U(A(t, n, 1, r.x, r.y, r.width, r.height));
    } else {
      g = _(t, n, l, r.x, r.y, r.width, r.height);
      d = U(_(t, n, l, r.x, r.y, r.width, r.height));
    }
    if (a) {
      if (e == 'image') {
        const f = new O();
        f.a(d);
        f.b(d, Math.ceil(15 * (n / RESOURCE_EDIT_SIZE)));
        f.f(d);
        f.g(d);
        const w = await T(i);
        const u = M(w.width, w.height, n, n, 0);
        const p = _(w, n, l || 1, u.x, u.y, u.width, u.height);
        const m = new B(g.width, g.height);
        m.ctx.drawImage(p, 0, 0);
        m.ctx.globalCompositeOperation = 'destination-in';
        m.ctx.drawImage(d, 0, 0);
        g.getContext('2d').drawImage(m.canvas, 0, 0);
      } else {
        const x = i.length * 48;
        const y = new B(x, x);
        y.ctx.textBaseline = 'top';
        y.ctx.font = '48px Noto Sans KR Regular';
        y.ctx.globalAlpha = 0.2;
        y.ctx.rotate((Math.PI / 180) * 25);
        y.ctx.fillText(i, 20, 0);
        const { maxWidth: I, maxHeight: b } = D(y);
        const E = new B(I, b);
        E.ctx.textBaseline = 'top';
        E.ctx.font = '48px Noto Sans KR Regular';
        E.ctx.globalAlpha = 0.2;
        E.ctx.rotate((Math.PI / 180) * 25);
        E.ctx.fillText(i, 10, 0);
        const m = new B(g.width, g.height);
        const R = Math.ceil((g.height + g.height / 2) / 48);
        const S = Math.ceil(g.width / I);
        for (let e = 0; e < R; e++) {
          for (let t = 0; t < S; t++) {
            m.ctx.drawImage(E.canvas, t * I + 20, e * 60 - g.height / 2);
          }
        }
        m.ctx.globalCompositeOperation = 'destination-in';
        m.ctx.drawImage(d, 0, 0);
        g.getContext('2d').drawImage(m.canvas, 0, 0);
      }
    }
    return await v(g, s);
  };
  const D = (t) => {
    const e = t.canvas.width;
    const n = t.ctx;
    const a = n.getImageData(0, 0, e, e);
    let i = a.data;
    const o = i.length;
    let s = 0;
    let h = 0;
    let c = 0;
    let l = 0;
    for (; h < o; h += 4, s++) {
      if (i[h + 3] > 50) {
        const r = h % (e * 4);
        const g = parseInt(h / (e * 4));
        c = Math.max(c, r / 4);
        l = Math.max(l, g);
      }
    }
    return { maxWidth: c, maxHeight: l };
  };
  const C = (t, e, n, a, i) => {
    let o;
    const s = i === 90 || i === 270;
    const h = s ? e : t;
    const c = s ? t : e;
    if (h >= c) {
      o = l('height', h, c, n, a, s);
      if (o.height > a) {
        o = l('width', h, c, n, a, s);
      }
    } else {
      o = l('width', h, c, n, a, s);
      if (o.width > n) {
        o = l('height', h, c, n, a, s);
      }
    }
    return {
      width: s ? o.height : o.width,
      height: s ? o.width : o.height,
      x: o.x,
      y: o.y,
    };
  };
  const M = (t, e, n, a, i) => {
    let o;
    const s = i === 90 || i === 270;
    const h = s ? e : t;
    const c = s ? t : e;
    if (h > c) {
      o = l('width', h, c, n, a, s);
      if (o.width < n) {
        o = l('height', h, c, n, a, s);
      }
    } else {
      o = l('height', h, c, n, a, s);
      if (o.height < a) {
        o = l('width', h, c, n, a, s);
      }
    }
    return {
      width: s ? o.height : o.width,
      height: s ? o.width : o.height,
      x: o.x,
      y: o.y,
    };
  };
  const l = (t, e, n, a, i, o) => {
    let s, h, c, l;
    if (t === 'width') {
      h = i;
      s = parseInt((i * e) / n, 10) || 0;
      c = parseInt(s - a, 10) / -2;
      l = 0;
    } else {
      s = a;
      h = parseInt((a * n) / e, 10) || 0;
      c = 0;
      l = parseInt(h - i, 10) / -2;
    }
    if (o) {
      c = parseInt(a - h, 10) / 2;
      l = parseInt(s - i, 10) / -2;
    }
    return { width: s, height: h, x: c, y: l };
  };
  const A = (t, e, n, a, i, o, s, h, c) => {
    const { canvas: l, ctx: r } = B(o * n, s * n);
    if (h) {
      r.globalAlpha = h;
    }
    if (c) {
      r.rotate(c);
    }
    r.drawImage(t, 0, 0, o * n, s * n);
    return l;
  };
  const _ = (t, e, n, a, i, o, s, h, c) => {
    const { canvas: l, ctx: r } = B(e * n, e * n);
    if (h) {
      r.globalAlpha = h;
    }
    if (c) {
      r.rotate(c);
    }
    r.drawImage(t, a * n, i * n, o * n, s * n);
    return l;
  };
  const v = (n, a) => {
    return new Promise((e, t) => {
      n.toBlob((t) => {
        e(t);
      }, a);
    });
  };
  const O = function () {
    this.binarizationArray = [];
    this.labelingData = [];
  };
  O.prototype.a = function (t) {
    const e = t.getContext('2d');
    const n = e.getImageData(0, 0, t.width, t.height);
    let a = n.data;
    const i = a.length;
    const o = this.binarizationArray;
    let s = 0;
    let h = 0;
    for (; h < i; h += 4, s++) {
      if (a[h + 3] > 125) {
        o[s] = 1;
      } else {
        o[s] = 0;
      }
    }
  };
  O.prototype.b = function (t, e) {
    this.c(t, e, false);
  };
  O.prototype.c = function (t, e, n = true) {
    const a = t.width;
    const i = this.binarizationArray;
    const o = i.length;
    let s = i.slice(0);
    let h = 0;
    const c = this.d;
    const l = this.e(e, n);
    for (; h < o; h++) {
      if (i[h] === 1) {
        const r = c(a, h, i);
        if (r) {
          let t = 0;
          const o = l.length;
          for (; t < o; t++) {
            const g = h + l[t][0] + l[t][1] * a;
            s[g] = n ? 1 : 0;
          }
        }
      }
    }
    this.binarizationArray = s;
  };
  O.prototype.d = function (t, e, n) {
    const a = [e - t, e - 1, e + 1, e + t];
    let i = 0;
    const o = a.length;
    for (; i < o; i++) {
      if (n[a[i]] === 0) {
        return true;
      }
    }
    return false;
  };
  O.prototype.e = function (n, a) {
    const i = [];
    for (let e = -n; e <= n; e++) {
      for (let t = -n; t <= n; t++) {
        if (a) {
          if (Math.round(Math.sqrt(e * e + t * t)) === n) {
            i.push([e, t]);
          }
        } else {
          if (Math.round(Math.sqrt(e * e + t * t)) <= n) {
            i.push([e, t]);
          }
        }
      }
    }
    return i;
  };
  O.prototype.f = function (t) {
    const e = this.binarizationArray;
    const n = e.length;
    const a = t.width;
    const i = [0];
    this.labelingData = new Array(n);
    while (i.length !== 0) {
      const o = i.shift();
      const s = [o - a, o + a, o - 1, o + 1];
      const h = s.length;
      let t = 0;
      for (; t < h; t++) {
        const c = s[t];
        if (e[c] === 0) {
          if (this.labelingData[c] !== 1) {
            this.labelingData[c] = 1;
            i.push(c);
          }
        } else if (e[c] === 1) {
          if (this.labelingData[c] !== 2) {
            this.labelingData[c] = 2;
          }
        }
      }
    }
  };
  O.prototype.g = function (t) {
    const e = this.labelingData.length;
    const n = t.getContext('2d');
    let a = n.getImageData(0, 0, t.width, t.height);
    let i = a.data;
    const o = 0,
      s = 1,
      h = 2,
      c = 3;
    let l = 0,
      r = 0;
    for (; l < e; l++, r += 4) {
      if (this.labelingData[l] === 2 || this.labelingData[l] === 1) {
        i[r + o] = 0;
        i[r + s] = 0;
        i[r + h] = 0;
        i[r + c] = 0;
      } else {
        i[r + o] = 255;
        i[r + s] = 255;
        i[r + h] = 255;
        i[r + c] = 255;
      }
    }
    n.putImageData(a, 0, 0);
  };
  const U = (t) => {
    const e = t.width;
    const n = t.height;
    const a = t.getContext('2d');
    a.save();
    a.globalCompositeOperation = 'source-atop';
    a.fillStyle = '#e6e6e6';
    a.fillRect(0, 0, e, n);
    a.restore();
    const { canvas: i, ctx: o } = B(e, n);
    o.drawImage(t, 0, 0);
    return i;
  };
  const B = function (t, e) {
    const n = document.createElement('canvas');
    n.width = t;
    n.height = e;
    const a = n.getContext('2d');
    return { canvas: n, ctx: a };
  };
  const T = (a) => {
    return new Promise((e, t) => {
      const n = document.createElement('img');
      n.crossOrigin = 'Anonymous';
      n.onload = (t) => {
        e(n);
      };
      n.onerror = () => {
        console.log('B: Image load Error : ' + n.src);
        t(false);
      };
      try {
        n.src = window.URL.createObjectURL(a);
      } catch (t) {
        n.src = a;
      }
    });
  };
  return async (t, e) => {
    const n = await T(t);
    let a = '';
    const i = t.name;
    if (t.type === 'image/jpg' || t.type === 'image/jpeg') {
      a = 'image/jpg';
    } else if (t.type === 'image/svg+xml') {
      a = 'image/png';
    } else if (t.type === 'image/png') {
      a = 'image/png';
    }
    const o = i.substr(i.lastIndexOf('.') + 1, i.length);
    const s = 'png';
    const h = e.isTwice
      ? await g(n, a)
      : await d(
          n,
          e.type,
          RESOURCE_EDIT_SIZE,
          e.thumbnail.edit.waterMark,
          e.source,
          e.thumbnail.edit.mode === 'paperFull',
          a,
          true,
        );
    const c = await d(n, e.type, RESOURCE_EDIT_SIZE, false, e.source, e.thumbnail.edit.mode === 'paperFull', a, true);
    const l = await d(
      n,
      e.type,
      RESOURCE_BASE_SIZE,
      e.thumbnail.tiny.waterMark,
      e.source,
      e.thumbnail.tiny.mode === 'paperFull',
      a,
      false,
      e.thumbnailData,
      4,
    );
    const r = await d(
      n,
      e.type,
      RESOURCE_BASE_SIZE,
      e.thumbnail.tiny.waterMark,
      e.source,
      e.thumbnail.tiny.mode === 'paperFull',
      a,
      false,
      e.thumbnailData,
      2,
    );
    return {
      ed: h,
      thumb: r,
      middle: l,
      realWidth: n.width,
      realHeight: n.height,
      editClearFile: c,
      fileExt: o,
      editFileExt: s,
    };
  };
})();
